<div class="row center u-t-divider">
  <div class="u-mw--500 col bg-white u-mt--large u-shadow u-br-3">
    <form class="form-signin">
      <h1 class="gretting__title u-mb--medium">
        {{ "login.gretting_title" | translate }}
      </h1>
      <h5 class="gretting__description">
        {{ "login.gretting_description" | translate: { brand: brand, link: link } }}
      </h5>
      <button
        (click)="loginToAzure()"
        type="button"
        class="button button-primary button-block u-mt--large u-mb--medium"
        [disabled]="isLoading">
        <app-loading-icon *ngIf="isLoading"></app-loading-icon>
        {{ (isLoading ? "button.pendingstate" : "button.login") | translate }}
      </button>
      <div class="divider">
        <div class="divider__line"></div>
        <span class="divider__text">{{ "login.or" | translate }}</span>
        <div class="divider__line"></div>
      </div>
      <button
        routerLink="{{ routeNameConstants.REQUEST_ACCOUNT }}"
        type="button"
        class="button button-secondary button-block u-mt--medium u-mb--medium">
        {{ "login.requestaccount" | translate }}
      </button>
    </form>
  </div>
</div>
